module.exports = __webpack_public_path__ + "img/new-banner.78692c0d.jpg";